// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__0mynd","list":"styles_list__z75OU","list-item":"styles_list-item__84Fug","listItem":"styles_list-item__84Fug","link":"styles_link__w+PKb"};